function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M265 .5l.3 54.6",
  stroke: "#019bda",
  strokeWidth: 3,
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M315.7 44c-.5.5-1 .7-1.7.6-.5 0-.7-.2-.7-.4-.7-1.4 1.6-5.5 4-9.4.1 4-.1 7.7-1.6 9.2zm-11.5 7.8c-.9 1-2.5 1.6-4 1.6-1.4 0-2.7-.5-3.6-1.4-1.2-1.3-1.8-3.2-1.6-5.2.5-3.9 3-7.3 5.7-10.6l.8 1.1c3.3 4.6 7.1 9.9 2.7 14.5zm47-28.7c-.1-.1-.2-.1-.4 0-.1 0-.2.1-.3.2-1 1.9-3.9 5.4-3.9 5.4-1.9 2.3-4.1 4.4-5.4 4.4-2.2 0-.7-4 2.2-10.4.2-.5.5-1.2.9-.8.4.4.2 1.8.1 2.5l1 .1c.2-1.2 0-4.6-1-5.8-.2-.3-.6-.4-1-.4-2.2.1-4 4.7-6.4 11.6l-2.5 6.7c-.8 0 3.1-11.7 2-13.7l-3.9-1.2c-.7 0-1.5.6-2.4 1.6.4-2 .5-2.9.1-3.1l-2.6-1.1c-1.5-.7-4.2 3.9-5.7 6.8-.3.5-.9 1.5-1.6 2.6 0-2.4.6-7.6.6-7.6l-3.4.1-.8 3.6c-.2 1-.9 2.6-1.8 3.9-.4.6-.9 1.3-1.4 1.8-.5.5-1.2.8-1.9.4-.5-.3-.7-1.2-.8-1.9-.1-1 .1-2.1.4-3.2l1.9-4.6h-2.8l-.2.2-3 5.3c-1.1 2.3-2.9 4.5-4.8 6.7-4.7-6.3-10.8-12.8-12.3-20.6-.4-2.3.2-4.7 1.2-6.7 1.2-2.4 4.2-4.4 5.6-4.4s2.8.5 4.1 1.5c1.4 1.1 2.2 2.8 2.1 4.3 0 .1 0 .3.2.4l.4.1c.2 0 .3 0 .3-.2.2-1.9-.8-3.9-2.5-5.3-3.1-2.5-7-2.7-10.4-.7-3.7 2.3-5.7 6.6-4.9 10.8 1.2 6.4 5.4 11.9 9.5 17.2 1.5 2 3 3.8 4.2 5.7v.1c-2.9 3.5-5.6 7.1-6.1 11.3-.3 2.3.4 4.5 1.8 6 1.1 1.1 2.6 1.7 4.3 1.7.7 0 2.3 0 3.9-.4.9-.2 2.8-1 3.7-1.9 5.4-5.7-.8-12.3-4-17.1l-.9-1.3c2-2.3 3.9-4.6 5.1-7.1v-.1c-.3 1.6-.2 3.1.7 4.2 1.2 1.4 2.4 1.4 3.3 1.2 2.1-.6 4-3.2 5-5.4-.1.7-.1 1.5 0 2.2l.1 1.2.2 3c-3.3 5.2-5.8 9.7-4.8 11.5.2.4.6.9 1.6.9.4 0 3.1 0 4.5-1 2.8-1.8 2.2-8.7 1.9-14.6v-.1c1.1-1.7 2-3 2.4-3.7 1.7-3.3 3.7-6.1 4.4-6.3.4 1.2-1.4 8.1-3.3 14.3h3.4s1.4-4.6 2.4-8.7c1.1-1.6 2.1-2.8 2.9-2.8.1 0 .3 0 .6.5.1.2.1.4.2.6-.2 4-3.4 12.7-2 15 .1.2.1.3.2.4.3.4.8.6 1.3.6 1.6 0 2.8-3 4.7-8.4 0 .9.2 1.7.7 2.4.5.7 1.2 1 2.2 1 2.5 0 6.5-4.4 9.4-8.6 0 0 1.1-1.7 1.5-2.4.1-.1.1-.2 0-.4.2.1.1 0 0 0m3.1-9.5H375v2.9h-8.7v23.8H363V16.5h-8.7v-2.9zm29.6 0h4.1l9 26.7h-3.5l-2.3-6.8h-10.6l-2.3 6.8h-3.5l9.1-26.7zm-2.5 17.3h8.9l-4.4-13.2-4.5 13.2zm24.3 6.5h11.9v2.9h-15.2V13.6h3.4v23.8zm19.9-23.8V26l11.9-12.3h4.6l-11.7 12 12.4 14.7h-4.3L428.2 28l-2.6 2.7v9.6h-3.4V13.6h3.4z",
  fill: "#019bda"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__a",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__a",
  overflow: "visible"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 23.7c.2-.3.3-.3.5 0l2.8 6.9c.1.4.2.6-.5.6H9.8c-.4 0-.6-.1-.4-.5l3.3-7zm5.4 12.2c.3.8.9 2.1.9 2.7 0 1.1-1.7.8-1.7 1.5 0 .3.5.3.6.3.8 0 1.5-.1 2.3-.1 1.2 0 2.3.1 3.5.1.2 0 .4 0 .4-.3 0-.7-1.7-.1-2.5-1.4-.7-1-1-2.2-1.4-3.2l-5.9-14.7c-.1-.2-.3-1.1-.6-1.1-.4 0-.5.5-2.1 4.1L4.7 38.3C4 39.9 2.6 39.4 2.6 40c0 .2.1.3.3.3.7 0 1.5-.1 2.3-.1.8 0 1.6.1 2.4.1.4 0 .8.1.8-.4 0-.7-2 .1-2-1.9 0-.4.1-.8.2-1l1.8-4c.3-.6.8-.6 1.3-.6H16c.8 0 1 .4 1.3 1.1l.8 2.4z",
  clipPath: "url(#logo_inline_svg__b)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__c",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__c",
  overflow: "visible"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 23.7c.2-.3.3-.3.5 0l2.8 6.9c.1.4.2.6-.5.6H9.8c-.4 0-.6-.1-.4-.5l3.3-7zm5.4 12.2c.3.8.9 2.1.9 2.7 0 1.1-1.7.8-1.7 1.5 0 .3.5.3.6.3.8 0 1.5-.1 2.3-.1 1.2 0 2.3.1 3.5.1.2 0 .4 0 .4-.3 0-.7-1.7-.1-2.5-1.4-.7-1-1-2.2-1.4-3.2l-5.9-14.7c-.1-.2-.3-1.1-.6-1.1-.4 0-.5.5-2.1 4.1L4.7 38.3C4 39.9 2.6 39.4 2.6 40c0 .2.1.3.3.3.7 0 1.5-.1 2.3-.1.8 0 1.6.1 2.4.1.4 0 .8.1.8-.4 0-.7-2 .1-2-1.9 0-.4.1-.8.2-1l1.8-4c.3-.6.8-.6 1.3-.6H16c.8 0 1 .4 1.3 1.1l.8 2.4z",
  clipPath: "url(#logo_inline_svg__d)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__e",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__e",
  overflow: "visible"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 23.7c.2-.3.3-.3.5 0l2.8 6.9c.1.4.2.6-.5.6H9.8c-.4 0-.6-.1-.4-.5l3.3-7zm5.4 12.2c.3.8.9 2.1.9 2.7 0 1.1-1.7.8-1.7 1.5 0 .3.5.3.6.3.8 0 1.5-.1 2.3-.1 1.2 0 2.3.1 3.5.1.2 0 .4 0 .4-.3 0-.7-1.7-.1-2.5-1.4-.7-1-1-2.2-1.4-3.2l-5.9-14.7c-.1-.2-.3-1.1-.6-1.1-.4 0-.5.5-2.1 4.1L4.7 38.3C4 39.9 2.6 39.4 2.6 40c0 .2.1.3.3.3.7 0 1.5-.1 2.3-.1.8 0 1.6.1 2.4.1.4 0 .8.1.8-.4 0-.7-2 .1-2-1.9 0-.4.1-.8.2-1l1.8-4c.3-.6.8-.6 1.3-.6H16c.8 0 1 .4 1.3 1.1l.8 2.4z",
  clipPath: "url(#logo_inline_svg__f)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__g",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__h"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__g",
  overflow: "visible"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 23.7c.2-.3.3-.3.5 0l2.8 6.9c.1.4.2.6-.5.6H9.8c-.4 0-.6-.1-.4-.5l3.3-7zm5.4 12.2c.3.8.9 2.1.9 2.7 0 1.1-1.7.8-1.7 1.5 0 .3.5.3.6.3.8 0 1.5-.1 2.3-.1 1.2 0 2.3.1 3.5.1.2 0 .4 0 .4-.3 0-.7-1.7-.1-2.5-1.4-.7-1-1-2.2-1.4-3.2l-5.9-14.7c-.1-.2-.3-1.1-.6-1.1-.4 0-.5.5-2.1 4.1L4.7 38.3C4 39.9 2.6 39.4 2.6 40c0 .2.1.3.3.3.7 0 1.5-.1 2.3-.1.8 0 1.6.1 2.4.1.4 0 .8.1.8-.4 0-.7-2 .1-2-1.9 0-.4.1-.8.2-1l1.8-4c.3-.6.8-.6 1.3-.6H16c.8 0 1 .4 1.3 1.1l.8 2.4z",
  clipPath: "url(#logo_inline_svg__h)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__i",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__j"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__i",
  overflow: "visible"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6 36.9c0 3.4-2.1 2.3-2.1 3.2 0 .1 0 .3.3.3.2 0 1.4-.1 2.3-.1 1.2 0 1.9.1 2.4.1.2 0 .3-.2.3-.3 0-.7-2.1.2-2.1-2v-9.9c0-.5.1-.6.2-.6.2 0 .5.4.5.5l10.4 11.7c.5.6.7.7.9.7.2 0 .2-.3.2-1v-14c0-1.8 1.4-1.3 1.4-2 0-.1-.1-.2-.2-.2-.6 0-1.6.1-2.4.1-.8 0-1.5-.1-2.2-.1-.1 0-.3.1-.3.2 0 .8 2.7-.1 2.7 3.1v10.1c0 .2 0 .3-.1.3s-.1-.1-.3-.3l-11.6-13c-.1-.2-.4-.6-.6-.6-.4 0-.7.1-1.1.1-.4 0-.7-.1-1.1-.1-.1 0-.4.1-.4.2 0 .9 2.9-.5 2.9 4.5v9.1z",
  clipPath: "url(#logo_inline_svg__j)"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__k",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__l"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__k",
  overflow: "visible"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6 36.9c0 3.4-2.1 2.3-2.1 3.2 0 .1 0 .3.3.3.2 0 1.4-.1 2.3-.1 1.2 0 1.9.1 2.4.1.2 0 .3-.2.3-.3 0-.7-2.1.2-2.1-2v-9.9c0-.5.1-.6.2-.6.2 0 .5.4.5.5l10.4 11.7c.5.6.7.7.9.7.2 0 .2-.3.2-1v-14c0-1.8 1.4-1.3 1.4-2 0-.1-.1-.2-.2-.2-.6 0-1.6.1-2.4.1-.8 0-1.5-.1-2.2-.1-.1 0-.3.1-.3.2 0 .8 2.7-.1 2.7 3.1v10.1c0 .2 0 .3-.1.3s-.1-.1-.3-.3l-11.6-13c-.1-.2-.4-.6-.6-.6-.4 0-.7.1-1.1.1-.4 0-.7-.1-1.1-.1-.1 0-.4.1-.4.2 0 .9 2.9-.5 2.9 4.5v9.1h0z",
  clipPath: "url(#logo_inline_svg__l)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__m",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref22 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__n"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__m",
  overflow: "visible"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6 36.9c0 3.4-2.1 2.3-2.1 3.2 0 .1 0 .3.3.3.2 0 1.4-.1 2.3-.1 1.2 0 1.9.1 2.4.1.2 0 .3-.2.3-.3 0-.7-2.1.2-2.1-2v-9.9c0-.5.1-.6.2-.6.2 0 .5.4.5.5l10.4 11.7c.5.6.7.7.9.7.2 0 .2-.3.2-1v-14c0-1.8 1.4-1.3 1.4-2 0-.1-.1-.2-.2-.2-.6 0-1.6.1-2.4.1-.8 0-1.5-.1-2.2-.1-.1 0-.3.1-.3.2 0 .8 2.7-.1 2.7 3.1v10.1c0 .2 0 .3-.1.3s-.1-.1-.3-.3l-11.6-13c-.1-.2-.4-.6-.6-.6-.4 0-.7.1-1.1.1-.4 0-.7-.1-1.1-.1-.1 0-.4.1-.4.2 0 .9 2.9-.5 2.9 4.5v9.1z",
  clipPath: "url(#logo_inline_svg__n)"
});

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__o",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref25 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__p"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__o",
  overflow: "visible"
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6 36.9c0 3.4-2.1 2.3-2.1 3.2 0 .1 0 .3.3.3.2 0 1.4-.1 2.3-.1 1.2 0 1.9.1 2.4.1.2 0 .3-.2.3-.3 0-.7-2.1.2-2.1-2v-9.9c0-.5.1-.6.2-.6.2 0 .5.4.5.5l10.4 11.7c.5.6.7.7.9.7.2 0 .2-.3.2-1v-14c0-1.8 1.4-1.3 1.4-2 0-.1-.1-.2-.2-.2-.6 0-1.6.1-2.4.1-.8 0-1.5-.1-2.2-.1-.1 0-.3.1-.3.2 0 .8 2.7-.1 2.7 3.1v10.1c0 .2 0 .3-.1.3s-.1-.1-.3-.3l-11.6-13c-.1-.2-.4-.6-.6-.6-.4 0-.7.1-1.1.1-.4 0-.7-.1-1.1-.1-.1 0-.4.1-.4.2 0 .9 2.9-.5 2.9 4.5v9.1z",
  clipPath: "url(#logo_inline_svg__p)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__q",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref28 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__r"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__q",
  overflow: "visible"
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8 23.6c-.1-3.4 2.2-2.2 2.2-3.1 0-.2-.1-.3-.3-.3-.5 0-.7.1-1.4.1-.1 0-1.1-.1-1.3-.1-.3 0-.6.7-.7 1l-6.8 13.6c-.5.9-.7 1.5-.9 1.5-.2 0-.3-.3-.6-.9l-6.8-14.5c-.1-.3-.2-.8-.6-.8-.5 0-1 .1-1.5.1s-1.1-.1-1.6-.1c-.3 0-.5.1-.5.3 0 1 2.7-.6 2.7 6.1 0 3-.3 6.1-.7 10.7-.2 3-2 1.8-2 2.8 0 .2.1.3.3.3.5 0 1-.1 2.5-.1.9 0 2.1.1 2.5.1.4 0 .7 0 .7-.3 0-1-2.7.2-2.6-3.6l.3-10c0-.3.1-.4.2-.4s.3.1.3.3L53.3 39c.1.2.3.8.6.8s.7-1.2.9-1.4l5.9-12c.3-.6.5-.9.7-.9.2 0 .3.4.3 1.1l.3 11.1c0 2.1-1.8 1.5-1.8 2.3 0 .1.1.3.3.3.7 0 1.6-.1 2.5-.1 1.1 0 2.1.1 2.7.1.3 0 .7 0 .7-.3 0-1-2.1.1-2.3-2.3l-.3-14.1z",
  clipPath: "url(#logo_inline_svg__r)"
});

var _ref30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__s",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref31 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__t"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__s",
  overflow: "visible"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8 23.6c-.1-3.4 2.2-2.2 2.2-3.1 0-.2-.1-.3-.3-.3-.5 0-.7.1-1.4.1-.1 0-1.1-.1-1.3-.1-.3 0-.6.7-.7 1l-6.8 13.6c-.5.9-.7 1.5-.9 1.5-.2 0-.3-.3-.6-.9l-6.8-14.5c-.1-.3-.2-.8-.6-.8-.5 0-1 .1-1.5.1s-1.1-.1-1.6-.1c-.3 0-.5.1-.5.3 0 1 2.7-.6 2.7 6.1 0 3-.3 6.1-.7 10.7-.2 3-2 1.8-2 2.8 0 .2.1.3.3.3.5 0 1-.1 2.5-.1.9 0 2.1.1 2.5.1.4 0 .7 0 .7-.3 0-1-2.7.2-2.6-3.6l.3-10c0-.3.1-.4.2-.4s.3.1.3.3L53.3 39c.1.2.3.8.6.8s.7-1.2.9-1.4l5.9-12c.3-.6.5-.9.7-.9.2 0 .3.4.3 1.1l.3 11.1c0 2.1-1.8 1.5-1.8 2.3 0 .1.1.3.3.3.7 0 1.6-.1 2.5-.1 1.1 0 2.1.1 2.7.1.3 0 .7 0 .7-.3 0-1-2.1.1-2.3-2.3l-.3-14.1z",
  clipPath: "url(#logo_inline_svg__t)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__u",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref34 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__v"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__u",
  overflow: "visible"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8 23.6c-.1-3.4 2.2-2.2 2.2-3.1 0-.2-.1-.3-.3-.3-.5 0-.7.1-1.4.1-.1 0-1.1-.1-1.3-.1-.3 0-.6.7-.7 1l-6.8 13.6c-.5.9-.7 1.5-.9 1.5-.2 0-.3-.3-.6-.9l-6.8-14.5c-.1-.3-.2-.8-.6-.8-.5 0-1 .1-1.5.1s-1.1-.1-1.6-.1c-.3 0-.5.1-.5.3 0 1 2.7-.6 2.7 6.1 0 3-.3 6-.7 10.7-.2 3-2 1.8-2 2.8 0 .2.1.3.3.3.5 0 1-.1 2.5-.1.9 0 2.1.1 2.5.1.4 0 .7 0 .7-.3 0-1-2.7.2-2.6-3.6l.3-10c0-.3.1-.4.2-.4s.3.1.3.3L53.3 39c.1.2.3.8.6.8s.7-1.2.9-1.4l5.9-12c.3-.6.5-.9.7-.9.2 0 .3.4.3 1.1l.3 11.1c0 2.1-1.8 1.5-1.8 2.3 0 .1.1.3.3.3.7 0 1.6-.1 2.5-.1 1.1 0 2.1.1 2.7.1.3 0 .7 0 .7-.3 0-1-2.1.1-2.3-2.3l-.3-14.1z",
  clipPath: "url(#logo_inline_svg__v)"
});

var _ref36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__w",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref37 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__x"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__w",
  overflow: "visible"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M63.8 23.6c-.1-3.4 2.2-2.2 2.2-3.1 0-.2-.1-.3-.3-.3-.5 0-.7.1-1.4.1-.1 0-1.1-.1-1.3-.1-.3 0-.6.7-.7 1l-6.8 13.6c-.5.9-.7 1.5-.9 1.5-.2 0-.3-.3-.6-.9l-6.8-14.5c-.1-.3-.2-.8-.6-.8-.5 0-1 .1-1.5.1s-1.1-.1-1.6-.1c-.3 0-.5.1-.5.3 0 1 2.7-.6 2.7 6.1 0 3-.3 6-.7 10.7-.2 3-2 1.8-2 2.8 0 .2.1.3.3.3.5 0 1-.1 2.5-.1.9 0 2.1.1 2.5.1.4 0 .7 0 .7-.3 0-1-2.7.2-2.6-3.6l.3-10c0-.3.1-.4.2-.4s.3.1.3.3L53.3 39c.1.2.3.8.6.8s.7-1.2.9-1.4l5.9-12c.3-.6.5-.9.7-.9.2 0 .3.4.3 1.1l.3 11.1c0 2.1-1.8 1.5-1.8 2.3 0 .1.1.3.3.3.7 0 1.6-.1 2.5-.1 1.1 0 2.1.1 2.7.1.3 0 .7 0 .7-.3 0-1-2.1.1-2.3-2.3l-.3-14.1z",
  clipPath: "url(#logo_inline_svg__x)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
});

var _ref39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__y",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref40 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__z"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__y",
  overflow: "visible"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3 0-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.8.1-.8.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3 0-.7-.1-1.3-.1-1.9 0-.8.1-1.6.1-2.4 0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.2-4.4z",
  clipPath: "url(#logo_inline_svg__z)"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__A",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref43 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__B"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__A",
  overflow: "visible"
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3 0-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.8.1-.8.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3 0-.7-.1-1.3-.1-1.9 0-.8.1-1.6.1-2.4 0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.2-4.4h0z",
  clipPath: "url(#logo_inline_svg__B)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__C",
  d: "M2.5-20.6h200v61.2H2.5z"
}));

var _ref46 = /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__D"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__C",
  overflow: "visible"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.7 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.9.1-.9.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3v-1.9-2.4c0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.1-4.4z",
  clipPath: "url(#logo_inline_svg__D)"
});

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__E",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__F"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__E",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.8 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.7 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.9.1-.9.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3v-1.9-2.4c0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.1-4.4h0z",
  clipPath: "url(#logo_inline_svg__F)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__G",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__H"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__G",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.9 25.3c0-1.1.1-1.5 2.4-1.5 4.6 0 8.2 3.1 8.2 8.5 0 5.6-3.3 7.4-6.7 7.4-1.1 0-2.9-.3-3.7-1.1-.2-.2-.1-1.4-.1-1.8l-.1-11.5zM84 37.8c0 2.3-1.7 1.7-1.7 2.3 0 .1 0 .2.2.2s2.5-.1 2.7-.1c1.2 0 2.5.1 3.7.1 6.7 0 9.4-3.9 9.4-9.4 0-4.5-4.2-7.7-8.5-7.7-2.1 0-3.7.1-5.3.1-.7 0-1.4-.1-2.2-.1-.1 0-.3.1-.3.2 0 .7 2-.1 2 2.4v12z",
  clipPath: "url(#logo_inline_svg__H)"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__I",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__J"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__I",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.9 25.3c0-1.1.1-1.5 2.4-1.5 4.6 0 8.2 3.1 8.2 8.5 0 5.6-3.3 7.4-6.7 7.4-1.1 0-2.9-.3-3.7-1.1-.2-.2-.1-1.4-.1-1.8l-.1-11.5zM84 37.8c0 2.3-1.7 1.7-1.7 2.3 0 .1 0 .2.2.2s2.5-.1 2.7-.1c1.2 0 2.5.1 3.7.1 6.7 0 9.4-3.9 9.4-9.4 0-4.5-4.2-7.7-8.5-7.7-2.1 0-3.7.1-5.3.1-.7 0-1.4-.1-2.2-.1-.1 0-.3.1-.3.2 0 .7 2-.1 2 2.4v12h0z",
  clipPath: "url(#logo_inline_svg__J)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__K",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__L"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__K",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.9 25.3c0-1.1.1-1.5 2.4-1.5 4.6 0 8.2 3.1 8.2 8.5 0 5.6-3.3 7.4-6.7 7.4-1.1 0-2.9-.3-3.7-1.1-.2-.2-.1-1.4-.1-1.8l-.1-11.5zM84 37.8c0 2.3-1.7 1.7-1.7 2.3 0 .1 0 .2.2.2s2.5-.1 2.7-.1c1.2 0 2.5.1 3.7.1 6.7 0 9.4-3.9 9.4-9.4 0-4.5-4.2-7.7-8.5-7.7-2.1 0-3.7.1-5.3.1-.7 0-1.4-.1-2.2-.1-.1 0-.3.1-.3.2 0 .7 2-.1 2 2.4v12z",
  clipPath: "url(#logo_inline_svg__L)"
}));

var _ref52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__M",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__N"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__M",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.9 25.3c0-1.1.1-1.5 2.4-1.5 4.6 0 8.2 3.1 8.2 8.5 0 5.6-3.3 7.4-6.7 7.4-1.1 0-2.9-.3-3.7-1.1-.2-.2-.1-1.4-.1-1.8l-.1-11.5zM84 37.8c0 2.3-1.7 1.7-1.7 2.3 0 .1 0 .2.2.2s2.5-.1 2.7-.1c1.2 0 2.5.1 3.7.1 6.7 0 9.4-3.9 9.4-9.4 0-4.5-4.2-7.7-8.5-7.7-2.1 0-3.7.1-5.3.1-.7 0-1.4-.1-2.2-.1-.1 0-.3.1-.3.2 0 .7 2-.1 2 2.4v12z",
  clipPath: "url(#logo_inline_svg__N)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__O",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__P"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__O",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.7 37.2c0 2.8-2.2 1.9-2.2 2.7 0 .3.1.4.3.4.1 0 .4-.1 2.5-.1 1.5 0 3.6.1 4 .1.3 0 .5-.1.5-.2 0-.9-2.7-.3-2.7-2.2v-7.1c0-.3 0-.5.3-.5h10.5c.3 0 .2.3.2.7v6.8c0 1.8-2 1.4-2 2.1 0 .5.4.4.7.4.5 0 1.3-.1 3.2-.1 1 0 1.9.1 2.7.1.2 0 .3-.3.3-.3 0-.7-2.6-.2-2.6-2.3V22.6c0-2 1.9-1.5 1.9-2 0-.2-.1-.5-.8-.5-.6 0-1 .1-2.1.1-.5 0-2-.1-3-.1-.4 0-.5.1-.5.3 0 .7 2.1.2 2.1 2.1v5.8c0 .1.1.8-.2.8h-10.4c-.4 0-.4-.1-.4-.5v-6.2c0-2.1 2.1-1.6 2.1-2.2 0-.1-.1-.3-.5-.3-.9 0-1.8.1-2.7.1-1.1 0-2.1-.1-3.1-.1-.2 0-.5.1-.5.3 0 .6 2.5.1 2.5 2.1l-.1 14.9z",
  clipPath: "url(#logo_inline_svg__P)"
}));

var _ref54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__Q",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__R"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__Q",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.7 37.2c0 2.8-2.2 1.9-2.2 2.7 0 .3.1.4.3.4.1 0 .4-.1 2.5-.1 1.5 0 3.6.1 4 .1.3 0 .5-.1.5-.2 0-.9-2.7-.3-2.7-2.2v-7.1c0-.3 0-.5.3-.5h10.5c.3 0 .2.3.2.7v6.8c0 1.8-2 1.4-2 2.1 0 .5.4.4.7.4.5 0 1.3-.1 3.2-.1 1 0 1.9.1 2.7.1.2 0 .3-.3.3-.3 0-.7-2.6-.2-2.6-2.3V22.6c0-2 1.9-1.5 1.9-2 0-.2-.1-.5-.8-.5-.6 0-1 .1-2.1.1-.5 0-2-.1-3-.1-.4 0-.5.1-.5.3 0 .7 2.1.2 2.1 2.1v5.8c0 .1.1.8-.2.8h-10.4c-.4 0-.4-.1-.4-.5v-6.2c0-2.1 2.1-1.6 2.1-2.2 0-.1-.1-.3-.5-.3-.9 0-1.8.1-2.7.1-1.1 0-2.1-.1-3.1-.1-.2 0-.5.1-.5.3 0 .6 2.5.1 2.5 2.1l-.1 14.9z",
  clipPath: "url(#logo_inline_svg__R)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__S",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__T"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__S",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.7 37.2c0 2.8-2.2 1.9-2.2 2.7 0 .3.1.4.3.4.1 0 .4-.1 2.5-.1 1.5 0 3.6.1 4 .1.3 0 .5-.1.5-.2 0-.9-2.7-.3-2.7-2.2v-7.1c0-.3 0-.5.3-.5h10.5c.3 0 .2.3.2.7v6.8c0 1.8-2 1.4-2 2.1 0 .5.4.4.7.4.5 0 1.3-.1 3.2-.1 1 0 1.9.1 2.7.1.2 0 .3-.3.3-.3 0-.7-2.6-.2-2.6-2.3V22.6c0-2 1.9-1.5 1.9-2 0-.2-.1-.5-.8-.5-.6 0-1 .1-2.1.1-.5 0-2-.1-3-.1-.4 0-.5.1-.5.3 0 .7 2.1.2 2.1 2.1v5.8c0 .1.1.8-.2.8h-10.4c-.4 0-.4-.1-.4-.5v-6.2c0-2.1 2.1-1.6 2.1-2.2 0-.1-.1-.3-.5-.3-.9 0-1.8.1-2.6.1-1.1 0-2.1-.1-3.1-.1-.2 0-.5.1-.5.3 0 .6 2.5.1 2.5 2.1l-.2 14.9z",
  clipPath: "url(#logo_inline_svg__T)"
}));

var _ref56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__U",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__V"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__U",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.7 37.2c0 2.8-2.2 1.9-2.2 2.7 0 .3.1.4.3.4.1 0 .4-.1 2.5-.1 1.5 0 3.6.1 4 .1.3 0 .5-.1.5-.2 0-.9-2.7-.3-2.7-2.2v-7.1c0-.3 0-.5.3-.5h10.5c.3 0 .2.3.2.7v6.8c0 1.8-2 1.4-2 2.1 0 .5.4.4.7.4.5 0 1.3-.1 3.2-.1 1 0 1.9.1 2.7.1.2 0 .3-.3.3-.3 0-.7-2.6-.2-2.6-2.3V22.6c0-2 1.9-1.5 1.9-2 0-.2-.1-.5-.8-.5-.6 0-1 .1-2.1.1-.5 0-2-.1-3-.1-.4 0-.5.1-.5.3 0 .7 2.1.2 2.1 2.1v5.8c0 .1.1.8-.2.8h-10.4c-.4 0-.4-.1-.4-.5v-6.2c0-2.1 2.1-1.6 2.1-2.2 0-.1-.1-.3-.5-.3-.9 0-1.8.1-2.6.1-1.1 0-2.1-.1-3.1-.1-.2 0-.5.1-.5.3 0 .6 2.5.1 2.5 2.1l-.2 14.9h0z",
  clipPath: "url(#logo_inline_svg__V)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__W",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__X"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__W",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.3 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.9.1-.9.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.8 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3v-1.9-2.4c0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8v-4.4z",
  clipPath: "url(#logo_inline_svg__X)"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__Y",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__Z"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__Y",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.3 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.9.1-.9.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.8 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3v-1.9-2.4c0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8v-4.4h0z",
  clipPath: "url(#logo_inline_svg__Z)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aa",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ab"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aa",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.3 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.8.1-.8.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1-.1 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3 0-.7-.1-1.3-.1-1.9 0-.8.1-1.6.1-2.4 0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.2-4.4z",
  clipPath: "url(#logo_inline_svg__ab)"
}));

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ac",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ad"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ac",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.3 25.7c0-1.6-.1-1.5 2.3-1.5 1 0 3.5-.1 4.1.7.4.6 0 1.7.6 1.7.1 0 .5-.2.5-2.9 0-.3-.1-.5-.2-.5-.8 0-3 .1-3.5.1-1 0-2.3-.1-6.9-.1-.7 0-.8.1-.8.3 0 .3.5.3.7.4 1.3.2 1.3 1.4 1.3 2.4v11.1c0 1.1-.1 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2v-4.5c0-.4-.1-.8.4-.8h3.6c2 0 1.2 2.1 2 2.1.2 0 .3-.1.3-.3 0-.7-.1-1.3-.1-1.9 0-.8.1-1.6.1-2.4 0-.2-.1-.5-.3-.5-.6 0 .1 1.9-2.4 1.9h-2.6c-1 0-.9 0-.9-.8l-.2-4.4h0z",
  clipPath: "url(#logo_inline_svg__ad)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ae",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__af"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ae",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M149.4 26.2c.1-.3.3-.3.4 0l2.4 5.8c.1.3.1.5-.4.5H147c-.3 0-.5-.1-.3-.4l2.7-5.9zm4.5 10.3c.2.7.8 1.8.8 2.3 0 .9-1.5.7-1.5 1.3 0 .2.4.2.5.2.7 0 1.3-.1 2-.1 1 0 2 .1 3 .1.2 0 .3 0 .3-.2 0-.6-1.4-.1-2.1-1.2-.6-.8-.8-1.9-1.2-2.8l-5-12.5c-.1-.2-.2-.9-.5-.9s-.4.4-1.8 3.4l-5.8 12.4c-.6 1.4-1.8 1-1.8 1.5 0 .1.1.3.2.3.6 0 1.3-.1 1.9-.1.7 0 1.4.1 2 .1.3 0 .7.1.7-.4 0-.6-1.7.1-1.7-1.6 0-.3.1-.7.2-.8l1.6-3.4c.2-.5.7-.5 1.1-.5h5.3c.7 0 .8.4 1.1.9l.7 2z",
  clipPath: "url(#logo_inline_svg__af)"
}));

var _ref62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ag",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ah"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ag",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M149.4 26.2c.1-.3.3-.3.4 0l2.4 5.8c.1.3.1.5-.4.5H147c-.3 0-.5-.1-.3-.4l2.7-5.9zm4.5 10.3c.2.7.8 1.8.8 2.3 0 .9-1.5.7-1.5 1.3 0 .2.4.2.5.2.7 0 1.3-.1 2-.1 1 0 2 .1 3 .1.2 0 .3 0 .3-.2 0-.6-1.4-.1-2.1-1.2-.6-.8-.8-1.9-1.2-2.8l-5-12.5c-.1-.2-.2-.9-.5-.9s-.4.4-1.8 3.4l-5.8 12.4c-.6 1.4-1.8 1-1.8 1.5 0 .1.1.3.2.3.6 0 1.3-.1 1.9-.1.7 0 1.4.1 2 .1.3 0 .7.1.7-.4 0-.6-1.7.1-1.7-1.6 0-.3.1-.7.2-.8l1.6-3.4c.2-.5.7-.5 1.1-.5h5.3c.7 0 .8.4 1.1.9l.7 2z",
  clipPath: "url(#logo_inline_svg__ah)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ai",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aj"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ai",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M149.4 26.2c.1-.3.3-.3.4 0l2.4 5.8c.1.3.1.5-.4.5H147c-.3 0-.5-.1-.3-.4l2.7-5.9zm4.5 10.3c.2.7.8 1.8.8 2.3 0 .9-1.5.7-1.5 1.3 0 .2.4.2.5.2.7 0 1.3-.1 2-.1 1 0 2 .1 3 .1.2 0 .3 0 .3-.2 0-.6-1.4-.1-2.1-1.2-.6-.8-.8-1.9-1.2-2.8l-5-12.5c-.1-.2-.2-.9-.5-.9s-.4.4-1.8 3.4l-5.8 12.4c-.6 1.4-1.8 1-1.8 1.5 0 .1.1.3.2.3.6 0 1.3-.1 1.9-.1.7 0 1.4.1 2 .1.3 0 .7.1.7-.4 0-.6-1.7.1-1.7-1.6 0-.3.1-.7.2-.8l1.6-3.4c.2-.5.7-.5 1.1-.5h5.3c.7 0 .8.4 1.1.9l.7 2z",
  clipPath: "url(#logo_inline_svg__aj)"
}));

var _ref64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ak",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__al"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ak",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M149.4 26.2c.1-.3.3-.3.4 0l2.4 5.8c.1.3.1.5-.4.5H147c-.3 0-.5-.1-.3-.4l2.7-5.9zm4.5 10.3c.2.7.8 1.8.8 2.3 0 .9-1.5.7-1.5 1.3 0 .2.4.2.5.2.7 0 1.3-.1 2-.1 1 0 2 .1 3 .1.2 0 .3 0 .3-.2 0-.6-1.4-.1-2.1-1.2-.6-.8-.8-1.9-1.2-2.8l-5-12.5c-.1-.2-.2-.9-.5-.9s-.4.4-1.8 3.4l-5.8 12.4c-.6 1.4-1.8 1-1.8 1.5 0 .1.1.3.2.3.6 0 1.3-.1 1.9-.1.7 0 1.4.1 2 .1.3 0 .7.1.7-.4 0-.6-1.7.1-1.7-1.6 0-.3.1-.7.2-.8l1.6-3.4c.2-.5.7-.5 1.1-.5h5.3c.7 0 .8.4 1.1.9l.7 2z",
  clipPath: "url(#logo_inline_svg__al)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__am",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__an"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__am",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M163 25.5c0-2.1 1.8-1.5 1.8-2.1 0-.3-.1-.3-.5-.3s-.9.1-2.3.1c-1.2 0-1.9-.1-2.5-.1-.3 0-.5 0-.5.3 0 .5 2 .3 2 1.6v12.3c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6 0 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.8 2.5-2 0-1.8-.6-1.8-2l.1-11.7z",
  clipPath: "url(#logo_inline_svg__an)"
}));

var _ref66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ao",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ap"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ao",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M163 25.5c0-2.1 1.8-1.5 1.8-2.1 0-.3-.1-.3-.5-.3s-.9.1-2.3.1c-1.2 0-1.9-.1-2.5-.1-.3 0-.5 0-.5.3 0 .5 2 .3 2 1.6v12.3c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8 0 3.7.1 5.5.1 1.1 0 1.6 0 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0 0 0-.3-.2-.3-.3 0-1.1 2.5-6.8 2.5-2 0-1.8-.6-1.8-2l.1-11.7z",
  clipPath: "url(#logo_inline_svg__ap)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aq",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ar"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aq",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M163 25.5c0-2.1 1.8-1.5 1.8-2.1 0-.3-.1-.3-.5-.3s-.9.1-2.3.1c-1.2 0-1.9-.1-2.4-.1-.3 0-.5.1-.5.3 0 .5 2 .3 2 1.6v12.3c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2l-.1-11.7z",
  clipPath: "url(#logo_inline_svg__ar)"
}));

var _ref68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__as",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__at"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__as",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M163 25.5c0-2.1 1.8-1.5 1.8-2.1 0-.3-.1-.3-.5-.3s-.9.1-2.3.1c-1.2 0-1.9-.1-2.4-.1-.3 0-.5.1-.5.3 0 .5 2 .3 2 1.6v12.3c0 1.1 0 1.8-.7 2.1-.8.4-1 .3-1.1.6 0 .2.1.2.4.2 1 0 2-.1 3-.1 1.8-.1 3.7.1 5.5.1 1.1 0 1.6.1 2.4-.8.6-.6 1.2-1.5 1.2-2.4 0-.1 0-.3-.2-.3-.3 0-1.1 2.5-6.7 2.5-2 0-1.8-.6-1.8-2l-.1-11.7z",
  clipPath: "url(#logo_inline_svg__at)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__au",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__av"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__au",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.6 38.2c0 1.5-1.9 1.2-1.9 1.8 0 .2.1.3.3.3.1 0 .6-.1 3.3-.1.7 0 1.4.1 2 .1.2 0 .2-.2.2-.3 0-.7-2 0-2-2V25.7c0-1.3-.1-1.2 1-1.2h3.5c2.5 0 1.2 1.8 2.1 1.8.3 0 .3-.3.3-.5l-.1-1.9c0-.6-.1-.7-.7-.7-.5 0-2.7.1-7.1.1-3.1 0-5-.1-6.9-.1-.4 0-.4.7-.4.9l-.3 2.4c0 .1.1.3.2.3.3 0 .3-.3.4-.6.4-1.3.5-1.7 2-1.7h4c.3 0 .2.9.2 1.1l-.1 12.6z",
  clipPath: "url(#logo_inline_svg__av)"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aw",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__ax"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aw",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.6 38.2c0 1.5-1.9 1.2-1.9 1.8 0 .2.1.3.3.3.1 0 .6-.1 3.3-.1.7 0 1.4.1 2 .1.2 0 .2-.2.2-.3 0-.7-2 0-2-2V25.7c0-1.3-.1-1.2 1-1.2h3.5c2.5 0 1.2 1.8 2.1 1.8.3 0 .3-.3.3-.5l-.1-1.9c0-.6-.1-.7-.7-.7-.5 0-2.7.1-7.1.1-3.1 0-5-.1-6.9-.1-.4 0-.4.7-.4.9l-.3 2.4c0 .1.1.3.2.3.3 0 .3-.3.4-.6.4-1.3.5-1.7 2-1.7h4c.3 0 .2.9.2 1.1l-.1 12.6h0z",
  clipPath: "url(#logo_inline_svg__ax)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__ay",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__az"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__ay",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.6 38.2c0 1.5-1.9 1.2-1.9 1.8 0 .2.1.3.3.3.1 0 .6-.1 3.3-.1.7 0 1.4.1 2 .1.2 0 .2-.2.2-.3 0-.7-2 0-2-2V25.7c0-1.3-.1-1.2 1-1.2h3.5c2.5 0 1.2 1.8 2.1 1.8.3 0 .3-.3.3-.5l-.1-1.9c0-.6-.1-.7-.7-.7-.5 0-2.7.1-7.1.1-3.1 0-5-.1-6.9-.1-.4 0-.4.7-.4.9l-.3 2.4c0 .1.1.3.2.3.3 0 .3-.3.4-.6.4-1.3.5-1.7 2-1.7h4c.3 0 .2.9.2 1.1l-.1 12.6z",
  clipPath: "url(#logo_inline_svg__az)"
}));

var _ref72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aA",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aB"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aA",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M175.6 38.2c0 1.5-1.9 1.2-1.9 1.8 0 .2.1.3.3.3.1 0 .6-.1 3.3-.1.7 0 1.4.1 2 .1.2 0 .2-.2.2-.3 0-.7-2 0-2-2V25.7c0-1.3-.1-1.2 1-1.2h3.5c2.5 0 1.2 1.8 2.1 1.8.3 0 .3-.3.3-.5l-.1-1.9c0-.6-.1-.7-.7-.7-.5 0-2.7.1-7.1.1-3.1 0-5-.1-6.9-.1-.4 0-.4.7-.4.9l-.3 2.4c0 .1.1.3.2.3.3 0 .3-.3.4-.6.4-1.3.5-1.7 2-1.7h4c.3 0 .2.9.2 1.1l-.1 12.6h0z",
  clipPath: "url(#logo_inline_svg__aB)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aC",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aD"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aC",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.9 37.7c0 2.4-1.9 1.6-1.9 2.3 0 .2.1.4.3.4.1 0 .4-.1 2.1-.1 1.3 0 3.1.1 3.4.1.2 0 .4-.1.4-.2 0-.7-2.3-.2-2.3-1.9v-6c0-.3 0-.4.3-.4h8.9c.3 0 .2.2.2.6v5.8c0 1.5-1.7 1.2-1.7 1.8 0 .4.4.3.6.3.5 0 1.1-.1 2.7-.1.9 0 1.6.1 2.3.1.2 0 .3-.2.3-.3 0-.6-2.2-.2-2.2-1.9v-13c0-1.7 1.6-1.3 1.6-1.7 0-.1 0-.4-.7-.4-.5 0-.8.1-1.7.1-.5 0-1.7-.1-2.5-.1-.4 0-.4.1-.4.3 0 .6 1.8.1 1.8 1.8v5c0 .1 0 .7-.2.7h-8.9c-.4 0-.4-.1-.4-.4v-5.2c0-1.8 1.7-1.4 1.7-1.8 0-.1 0-.2-.5-.2-.8 0-1.5.1-2.3.1-.9 0-1.8-.1-2.7-.1-.2 0-.4 0-.4.3 0 .5 2.1 0 2.1 1.8l.1 12.3z",
  clipPath: "url(#logo_inline_svg__aD)"
}));

var _ref74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aE",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aE",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.9 37.7c0 2.4-1.9 1.6-1.9 2.3 0 .2.1.4.3.4.1 0 .4-.1 2.1-.1 1.3 0 3.1.1 3.4.1.2 0 .4-.1.4-.2 0-.7-2.3-.2-2.3-1.9v-6c0-.3 0-.4.3-.4h8.9c.3 0 .2.2.2.6v5.8c0 1.5-1.7 1.2-1.7 1.8 0 .4.4.3.6.3.5 0 1.1-.1 2.7-.1.9 0 1.6.1 2.3.1.2 0 .3-.2.3-.3 0-.6-2.2-.2-2.2-1.9v-13c0-1.7 1.6-1.3 1.6-1.7 0-.1 0-.4-.7-.4-.5 0-.8.1-1.7.1-.5 0-1.7-.1-2.5-.1-.4 0-.4.1-.4.3 0 .6 1.8.1 1.8 1.8v5c0 .1 0 .7-.2.7h-8.9c-.4 0-.4-.1-.4-.4v-5.2c0-1.8 1.7-1.4 1.7-1.8 0-.1 0-.2-.5-.2-.8 0-1.5.1-2.3.1-.9 0-1.8-.1-2.7-.1-.2 0-.4 0-.4.3 0 .5 2.1 0 2.1 1.8l.1 12.3z",
  clipPath: "url(#logo_inline_svg__aF)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 10
}));

var _ref75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aG",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aH"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aG",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.9 37.7c0 2.4-1.9 1.6-1.9 2.3 0 .2.1.4.3.4.1 0 .4-.1 2.1-.1 1.3 0 3.1.1 3.4.1.2 0 .4-.1.4-.2 0-.7-2.3-.2-2.3-1.9v-6c0-.3 0-.4.3-.4h8.9c.3 0 .2.2.2.6v5.8c0 1.5-1.7 1.2-1.7 1.8 0 .4.4.3.6.3.5 0 1.1-.1 2.7-.1.9 0 1.6.1 2.3.1.2 0 .3-.2.3-.3 0-.6-2.2-.2-2.2-1.9v-13c0-1.7 1.6-1.3 1.6-1.7 0-.1 0-.4-.7-.4-.5 0-.8.1-1.7.1-.5 0-1.7-.1-2.5-.1-.4 0-.4.1-.4.3 0 .6 1.8.1 1.8 1.8v5c0 .1 0 .7-.2.7h-8.9c-.4 0-.4-.1-.4-.4v-5.2c0-1.8 1.7-1.4 1.7-1.8 0-.1 0-.2-.5-.2-.8 0-1.5.1-2.3.1-.9 0-1.8-.1-2.7-.1-.2 0-.4.1-.4.3 0 .5 2.1.1 2.1 1.8l.1 12.3z",
  clipPath: "url(#logo_inline_svg__aH)"
}));

var _ref76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aI",
  d: "M2.5-20.6h200v61.2H2.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aJ"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aI",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186.9 37.7c0 2.4-1.9 1.6-1.9 2.3 0 .2.1.4.3.4.1 0 .4-.1 2.1-.1 1.3 0 3.1.1 3.4.1.2 0 .4-.1.4-.2 0-.7-2.3-.2-2.3-1.9v-6c0-.3 0-.4.3-.4h8.9c.3 0 .2.2.2.6v5.8c0 1.5-1.7 1.2-1.7 1.8 0 .4.4.3.6.3.5 0 1.1-.1 2.7-.1.9 0 1.6.1 2.3.1.2 0 .3-.2.3-.3 0-.6-2.2-.2-2.2-1.9v-13c0-1.7 1.6-1.3 1.6-1.7 0-.1 0-.4-.7-.4-.5 0-.8.1-1.7.1-.5 0-1.7-.1-2.5-.1-.4 0-.4.1-.4.3 0 .6 1.8.1 1.8 1.8v5c0 .1 0 .7-.2.7h-8.9c-.4 0-.4-.1-.4-.4v-5.2c0-1.8 1.7-1.4 1.7-1.8 0-.1 0-.2-.5-.2-.8 0-1.5.1-2.3.1-.9 0-1.8-.1-2.7-.1-.2 0-.4.1-.4.3 0 .5 2.1.1 2.1 1.8l.1 12.3z",
  clipPath: "url(#logo_inline_svg__aJ)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.535,
  strokeMiterlimit: 3.864
}));

var _ref77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aK",
  d: "M168.7 17.6h125v38.2h-125z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aL"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aK",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M253.1 34.8l-8.7-15.7c-.7-1.4-2.5-1.8-3.8-1.1l-.5.3c-1.4.7-1.8 2.5-1.1 3.8l8.7 15.7c.7 1.4 2.5 1.8 3.8 1.1l.5-.3c1.4-.8 1.9-2.5 1.1-3.8",
  clipPath: "url(#logo_inline_svg__aL)",
  fill: "#56a0d3"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aM",
  d: "M168.7 17.6h125v38.2h-125z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aN"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aM",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M243 34.7L234.3 19c-.7-1.4-2.5-1.8-3.8-1.1l-.5.3c-1.3.7-1.8 2.5-1.1 3.8l8.7 15.7c.7 1.4 2.5 1.8 3.8 1.1l.5-.3c1.4-.7 1.9-2.4 1.1-3.8",
  clipPath: "url(#logo_inline_svg__aN)",
  fill: "#56a0d3"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aO",
  d: "M168.7 17.6h125v38.2h-125z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aP"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aO",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M233 34.7L224.3 19c-.7-1.4-2.5-1.8-3.8-1.1l-.5.3c-1.4.7-1.8 2.5-1.1 3.8l8.7 15.7c.7 1.4 2.5 1.8 3.8 1.1l.5-.3c1.4-.7 1.9-2.4 1.1-3.8",
  clipPath: "url(#logo_inline_svg__aP)",
  fill: "#56a0d3"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo_inline_svg__aQ",
  d: "M168.7 17.6h125v38.2h-125z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_inline_svg__aR"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_inline_svg__aQ",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M210.3 34.7l6.4-11.5c.8 1.3 2.7 5 3.5 6.4l-4.4 8.1c-.7 1.4-2.5 1.8-3.8 1.1l-.6-.3c-1.3-.7-1.8-2.4-1.1-3.8",
  clipPath: "url(#logo_inline_svg__aR)",
  fill: "#56a0d3"
})));

function SvgLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444 54.6"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77);
}

export default SvgLogoinline;